import { apiPatch } from '../client';
import { BusinessProfileSchema, type BusinessProfile } from '../schemas';

export type PatchProfileInput = {
  name?: string;
  tagline?: string;
  emoji?: string;
  neighborhood?: string;
  priceLevel?: 1 | 2 | 3;
  cuisine?: string | null;
  address?: string | null;
  /** Public venue contact, never the owner account's login or recovery phone. */
  contactPhoneE164?: string | null;
  /** Always set or cleared together with `lng`. */
  lat?: number | null;
  lng?: number | null;
  /** "Cerrado temporalmente". A platform suspension is not patchable here. */
  isPaused?: boolean;
  /** The profile version the form read; a stale one comes back 409 version_conflict. */
  expectedVersion?: number;
};

export function patchBusinessProfile(
  input: PatchProfileInput,
  idempotencyKey: string,
): Promise<BusinessProfile> {
  return apiPatch('/v1/business/profile', BusinessProfileSchema, input, idempotencyKey);
}
